<template>
    <div class="row bgc-wrapper margin-top-42">
    <div class="col-lg-12 col-md-12 col-sm-12 traveller-heading accordion-toggle">
      <div class="row">
        <div>
          <button
            id="regist_no_correction"
            type="button"
            class="expand-form-button"
            data-toggle="collapse"
            aria-label="Expand Journey Details"
            data-target="#regNoCorrection"
          >
            <img alt="Toggle Policy Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <h3>Registration No Correction</h3>
      </div>
    </div>
    <div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="regNoCorrection">
        <div class="row">
            <!-- Registration Location starts -->
        <!--Registration Number starts-->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 col-6 p-0 mt-0" v-if="registrationNoCorrectionData.registrationNumber.visibility">
          <div class="col-6 pl-0">
            <RegNumSearch :regNumError="regNumError" :registrationData="registrationNoCorrectionData.registrationNumber" :businessType="getSavedQuoteData.basicDetails.businessType" @setvehicledetails="setRegData"></RegNumSearch>
          </div>
          <!-- <div class="loader-small mt-auto reg-loader" v-show="showRegLoader">
            <img src="@/assets/images/loader.gif" alt="done">
          </div> -->
        </div>
        <!--Registration Number ends-->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0" v-if="registrationNoCorrectionData.rtaCity.visibility">
          <float-label label="Registration Location*" :fixed="isFloat(registrationNoCorrectionData.rtaCity.value)">
            <v-select
              @search:blur="checkError(registrationNoCorrectionData.rtaCity,false)+setErrorClass(registrationNoCorrectionData.rtaCity,'rtaCity')"
              class="v-select-form form-control rtaCity"
              :map-keydown="handlersRta"
              @input="callGetRtaDetails()"
              :disabled="rtaLocationsData.length<=1"
              :class="{'bgc-error-field':  registrationNoCorrectionData.rtaCity.errorText !== '',
              'remove_placeholder': registrationNoCorrectionData.rtaCity.value }"
              placeholder="Registration Location*"
              :options="intrimRegLocList"
              v-model="registrationNoCorrectionData.rtaCity.value"
              v-evolvews="registrationNoCorrectionData.rtaCity"
              :reduce="intrimRegLocList => intrimRegLocList.value"
            >
            </v-select>
          </float-label>
          <span
            class="error-text"
            v-if="registrationNoCorrectionData.rtaCity.errorText!==''"
          >{{registrationNoCorrectionData.rtaCity.errorText}}</span>
        </div>
        <!-- Registration Location ends -->
        <!--Pin Code(RTA)* starts-->
          <!-- <div class="col-lg-3 col-md-3 col-sm-6">
            <div class="row form-group">
              <float-label label="Pin Code(RTA)*" :fixed="isFloat(registrationNoCorrectionData.rtaPincode.value)"> 
                <input
                  v-model="registrationNoCorrectionData.rtaPincode.value"
                  v-evolvews="registrationNoCorrectionData.rtaPincode"
                  type="text"
                  v-on:keydown="onlyNumber"
                  maxlength="6"
                  :class="{'bgc-error-field':registrationNoCorrectionData.rtaPincode.errorText !== '',}"
                  class="form-control"
                  placeholder="Pin Code(RTA)*"
                  disabled
                />
              </float-label>
               <span class="error-text" v-if="registrationNoCorrectionData.rtaPincode.errorText !== ''">
                    {{registrationNoCorrectionData.rtaPincode.errorText}}</span>
            </div>
          </div> -->
          <!--Pin Code(RTA)* ends-->
        </div>
        <!-- <div class="row"> -->
            <!--Registration Authority starts-->
          <!-- <div class="col-lg-3 col-md-3 col-sm-6">
            <div class="row form-group">
              <float-label label="Registration Authority" :fixed="isFloat(registrationNoCorrectionData.registrationAuthority.value)"> 
                <input
                  v-model="registrationNoCorrectionData.registrationAuthority.value"
                  v-evolvews="registrationNoCorrectionData.registrationAuthority"
                  type="text"
                  class="form-control"
                  placeholder="Registration Authority"
                  disabled
                />
              </float-label>
               <span class="error-text" v-if="registrationNoCorrectionData.registrationAuthority.errorText !== ''">
                    {{registrationNoCorrectionData.registrationAuthority.errorText}}</span>
            </div>
          </div> -->
          <!--Registration Authority ends-->
        <!-- </div> -->
    </div>
</div>
</template>
<script>
import RegNumSearch from "@/../../shared_motor_component/RegNumSearch.vue";
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import Datepicker from "vuejs-datepicker";
import functions from "@/../../masters/functions.js";
// import base from "@/../../masters/base.js";
// import Breadcrumb from "@/../../shared_component/Breadcrumb.vue";
import vSelect from "vue-select";
// import moment from "moment";
import "vue-select/dist/vue-select.css";
import {reactive, ref, onMounted, computed, watch, onUpdated } from "@vue/composition-api";
export default {
  name: "RegistrationNoCorrection",
  props: ["registrationNoCorrectionData","showRegLoader","rtaLocationsData","getSavedQuoteData",'regNumError'],
  components: {
    FloatLabel,
    Datepicker,
    vSelect,
    RegNumSearch
  },
  setup(props, context) {
    let state = reactive({});
    const checkError = functions.checkError;
    const isInputError = functions.isInputError;
    const isFloat = functions.isFloat;
    const onlyNumber = functions.onlyNumber;

    onUpdated(()=>{
      let progressStep = 0;
      Object.values(props.registrationNoCorrectionData).forEach(obj => {
        if(obj.stepsMandatory){
          if(obj.value && !obj.errorText){
            progressStep++;
          }
        }
      })
      context.parent.updateSteps(progressStep);
      context.parent.enableCalculatePremiumBtn('registrationNoCorrection');
    })
    const intrimRegLocList = computed(()=>
      props.rtaLocationsData.map(obj=>{
        return {
          label: obj.rtaCode+" - "+obj.rtaCity,
          value: obj.rtaCode+"-"+obj.rtaCity
        }
      })
    )
    function setRegData(e){
      setTimeout(function(){if(e.target.placeholder == "Vehicle Registration Number*") e.target.placeholder = ""},10) //placeholder fix for first box in reg no
      // let self=this;
      // props.vehicleData.yearOfManufacture.value = null;
      // props.vehicleData.dateOfRegistration.value = null;
      let regNum = props.registrationNoCorrectionData.registrationNumber;
      if(/[0-9]{2}/.test(regNum.values[0]) && regNum.values[1] == 'BH'){
        if(regNum.values.every(val=> val != "") && !regNum.errorText){
          props.registrationNoCorrectionData.registrationNumber.value = regNum.values.join('-');
          props.registrationNoCorrectionData.registrationNumber.errorText = "";
          context.parent.callGetBlockRtaBharatReg();
        }else{
          context.parent.resetRegistrationData();
        }
      }else{
        let regNumValue = regNum.values.join('');
        // let regNumberCheckFlag = true;
        if(regNum.values.filter((val,index)=> index!== 2).every(val=> val!="") && regNum.errorText=='' && regNumValue!='NEW'){
          // state.loaderEnabled = true;
          props.registrationNoCorrectionData.registrationNumber.value = regNum.values[2] ? regNum.values.join('-'): [regNum.values[0],regNum.values[1],regNum.values[3]].join('-');
          props.registrationNoCorrectionData.registrationNumber.errorText = ""
          //regNumberCheckFlag = true;
          context.parent.getBlockRta();
        }
        else{
          context.parent.resetRegistrationData();
          if( regNumValue=='NEW' && regNum.errorText==''){
            context.parent.getRtaLocation('regNoCorrection');
          }
        }
      }
    }
    function callGetRtaDetails(){
      context.parent.getRtaDetails(true);
    }
    const handlersRta = (map) => ({
      ...map,
      8 : (e)=>{
        const elementDivRta = document.querySelector('.rtaCity');
        if(!elementDivRta.classList.contains("vs--searching")){
          e.preventDefault();
        }
      }
    })
    function setErrorClass(objToCheck,selector){
      if(objToCheck.value == "" || objToCheck.value == null){
        objToCheck.errorText = objToCheck.errorMessage;
        $("."+selector).find("input")[0].classList.add("v-select-error-field");
      }
      else{
        objToCheck.errorText = "";
        $("."+selector).find("input")[0].classList.toggle("v-select-error-field",false)
      }
    }
    return {
      state,
      isFloat,
      checkError,
      isInputError,
      setRegData,
      handlersRta,
      setErrorClass,
      onlyNumber,
      intrimRegLocList,
      callGetRtaDetails
    };
  },
   directives: {
    evolvews: functions.evolvews
  }
}
</script>
<style scoped>
.v-select-error-field{
  color: #f77a7a !important
}
</style>

